import { Moment } from 'moment';
import Vehicle from '@/vehicle/models/Vehicle';
import AlarmCertificateStatus from '../constants/AlarmCertificateStatus';
import AlarmCertificate from './AlarmCertificate';
import Dossier from './Dossier';
import ExtendedProperty from './ExtendedProperty';
import Keybox from './Keybox';

export default class DossierVehicle {
  dossier!: Dossier;
  vehicle!: Vehicle;
  inspectionDate: Moment | null = null;
  alarmCertificateStatus!: AlarmCertificateStatus;
  alarmCertificates: Array<AlarmCertificate> = [];
  keybox: Keybox | null = null;
  extendedProperties: Array<ExtendedProperty> = [];
}
